(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MAD';

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[character]);

  const formatMoney = (cents, currency = activeCurrency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-MA', {
        style: 'currency', currency, minimumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  const showToast = (message) => {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  const closeDrawers = () => {
    document.querySelectorAll('.drawer.is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('drawer-open');
  };

  const openDrawer = (id) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    window.setTimeout(() => drawer.querySelector('input, button, a')?.focus(), 120);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  const cartItemMarkup = (item, line, currency) => {
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=180` : '';
    const image = imageUrl
      ? `<img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<small>${escapeHTML(item.variant_title)}</small>`
      : '';
    const properties = item.properties
      ? Object.entries(item.properties)
          .filter(([key, value]) => value && !key.startsWith('_'))
          .map(([key, value]) => `<small>${escapeHTML(key)}: ${escapeHTML(value)}</small>`).join('')
      : '';
    return `<article class="mini-cart-item" data-line="${line}">
      <a href="${escapeHTML(item.url)}" class="mini-cart-item__image">${image}</a>
      <div class="mini-cart-item__info">
        <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a>
        ${variant}${properties}
        <div class="mini-cart-item__bottom">
          <div class="quantity-input quantity-input--small">
            <button type="button" data-cart-change="${line}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${line}" data-quantity="${item.quantity + 1}">+</button>
          </div>
          <strong>${formatMoney(item.final_line_price, currency)}</strong>
        </div>
      </div>
    </article>`;
  };

  const renderCart = (cart) => {
    const currency = cart.currency || activeCurrency;
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = cart.item_count;
      if (element.classList.contains('cart-count')) element.hidden = cart.item_count === 0;
    });
    const itemsContainer = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    const total = document.querySelector('[data-cart-total]');
    if (!itemsContainer) return;
    if (!cart.item_count) {
      itemsContainer.innerHTML = `<div class="empty-state"><p>Votre panier est vide.</p><a class="button button--primary" href="${root}collections/all">Découvrir la boutique</a></div>`;
      if (footer) footer.hidden = true;
      return;
    }
    itemsContainer.innerHTML = cart.items.map((item, index) => cartItemMarkup(item, index + 1, currency)).join('');
    if (footer) footer.hidden = false;
    if (total) total.textContent = formatMoney(cart.total_price, currency);
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Impossible de charger le panier.');
    return response.json();
  };

  document.addEventListener('click', async (event) => {
    const changer = event.target.closest('[data-cart-change]');
    if (!changer) return;
    event.preventDefault();
    changer.disabled = true;
    const buyNow = form.dataset.buyNow === 'true';
    delete form.dataset.buyNow;
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(changer.dataset.cartChange), quantity: Number(changer.dataset.quantity) })
      });
      if (!response.ok) throw new Error('La quantité n’a pas pu être modifiée.');
      renderCart(await response.json());
    } catch (error) {
      showToast(error.message);
      changer.disabled = false;
    }
  });

  const extractProperties = (formData) => {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)]$/);
      if (match && value) properties[match[1]] = value;
    }
    return properties;
  };

  document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');

  if (!form) return;

  event.preventDefault();

  if (form.dataset.submitting === 'true') return;

  form.dataset.submitting = 'true';

  /*
   * Read Buy Now mode inside the product form handler.
   * Add to Cart = false
   * Commander maintenant = true
   */
  const buyNow = form.dataset.buyNow === 'true';
  delete form.dataset.buyNow;

  const addButton = form.querySelector('[data-add-to-cart]');
  const buyButton = form.querySelector('[data-buy-now]');
  const submitLabel = addButton?.querySelector('[data-add-to-cart-text]');

  const originalAddLabel = submitLabel?.textContent;
  const originalBuyLabel = buyButton?.textContent;
  const activeButton = buyNow ? buyButton : addButton;

  if (activeButton) {
    activeButton.disabled = true;
  }

  /*
   * Animate only the button that the customer clicked.
   */
  if (buyNow) {
    if (buyButton) {
      buyButton.textContent = 'REDIRECTION…';
    }
  } else if (submitLabel) {
    submitLabel.textContent = 'AJOUT…';
  }

  try {
    const formData = new FormData(form);
    const addOnVariant = Number(form.dataset.addonVariant || 0);

    const personalizationActive = Boolean(
      form.querySelector('[data-personalization-toggle]:checked')
    );

    let response;

    /*
     * Add the product and personalization supplement together.
     */
    if (addOnVariant && personalizationActive) {
      const quantity = Math.max(
        1,
        Number(formData.get('quantity') || 1)
      );

      const properties = extractProperties(formData);

      const productTitle =
        form
          .closest('[data-product-section]')
          ?.querySelector('h1')
          ?.textContent
          ?.trim() || 'Produit HUSA';

      response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(formData.get('id')),
              quantity,
              properties
            },
            {
              id: addOnVariant,
              quantity,
              properties: {
                ...properties,
                _Produit: productTitle
              }
            }
          ]
        })
      });
    } else {
      /*
       * Add the normal product.
       */
      response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      });
    }

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Ce produit n’a pas pu être ajouté.'
      );
    }

    /*
     * Get Shopify’s complete cart after adding the product.
     */
    const cart = await getCart();

    renderCart(cart);

    if (buyNow) {
      /*
       * The current product has now been added to the existing cart.
       * Checkout should therefore contain all cart products.
       */
      window.location.href = `${root}checkout`;
    } else {
      /*
       * Normal Add to Cart:
       * open the cart drawer and remain on the product page.
       */
      openDrawer('cart-drawer');
      showToast('Produit ajouté au panier.');
    }
  } catch (error) {
    showToast(
      error.message ||
      'Une erreur est survenue. Veuillez réessayer.'
    );
  } finally {
    delete form.dataset.submitting;

    if (activeButton) {
      activeButton.disabled = false;
    }

    if (submitLabel && originalAddLabel) {
      submitLabel.textContent = originalAddLabel;
    }

    if (buyButton && originalBuyLabel) {
      buyButton.textContent = originalBuyLabel;
    }
  }
});

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const json = section.querySelector('[data-product-json]');
    if (!form || !json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }

    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const buyButton = form.querySelector('[data-buy-now]');
    const addText = form.querySelector('[data-add-to-cart-text]');
    const price = section.querySelector('[data-product-price]');

    const updateVariant = () => {
      const selectedOptions = [...form.querySelectorAll('[data-option-position]')]
        .map((group) => group.querySelector('input:checked')?.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index])) || variants.find((candidate) => String(candidate.id) === idInput?.value);
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (buyButton) buyButton.disabled = true;
        if (addText) addText.textContent = 'INDISPONIBLE';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.innerHTML = `${formatMoney(variant.price)}${variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
      if (addButton) addButton.disabled = !variant.available;
      if (buyButton) buyButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
      if (variant.featured_media?.id) activateProductMedia(section, variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-position] input')) updateVariant();
    });

    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      const input = form.querySelector('[name="quantity"]');
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const input = form.querySelector('[name="quantity"]');
      input.value = Math.max(1, Number(input.value || 1) + 1);
    });

    const personalizationToggle = form.querySelector('[data-personalization-toggle]');
    personalizationToggle?.addEventListener('change', () => {
      const fields = form.querySelector('[data-personalization-fields]');
      if (!fields) return;
      fields.hidden = !personalizationToggle.checked;
      fields.querySelectorAll('input').forEach((input) => { input.disabled = !personalizationToggle.checked; });
    });

    buyButton?.addEventListener('click', () => {
      form.dataset.buyNow = 'true';
      form.requestSubmit();
    });
  });

  function activateProductMedia(section, mediaId) {
    section.querySelectorAll('[data-product-media]').forEach((media) => media.classList.toggle('is-active', String(media.dataset.productMedia) === String(mediaId)));
    section.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', String(thumb.dataset.productThumb) === String(mediaId)));
  }

  document.addEventListener('click', (event) => {
    const productThumb = event.target.closest('[data-product-thumb]');
    if (productThumb) activateProductMedia(productThumb.closest('[data-product-section]'), productThumb.dataset.productThumb);

    const galleryThumb = event.target.closest('[data-gallery-thumb]');
    if (galleryThumb) {
      const gallery = galleryThumb.closest('.spotlight-gallery');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === galleryThumb));
      gallery.querySelectorAll('[data-gallery-media]').forEach((media) => media.classList.toggle('is-active', media.dataset.galleryMedia === galleryThumb.dataset.galleryThumb));
    }

    if (event.target.closest('[data-size-guide-open]')) {
      event.preventDefault();
      event.target.closest('[data-product-section]')?.querySelector('[data-size-guide]')?.showModal();
    }
    if (event.target.closest('[data-size-guide-close]')) event.target.closest('[data-size-guide]')?.close();
  });

  document.querySelectorAll('[data-auto-submit]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  document.querySelectorAll('[data-recommendations-url]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.recommendationsUrl);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-recommendations-url]');
      if (replacement && replacement.innerHTML.trim()) section.replaceWith(replacement);
    } catch (error) {
      // Recommendations are optional; the product page remains fully usable.
    }
  });
})();
